import { useCallback } from 'react'

import { useApiMutation } from '../../hooks/useApiMutation'
import { ChatMessageResponse, SendChatMessageRequest } from '../../types/chat'
import urlRepository from '../../utils/constants/urlRepository'
import { useChatContext } from './ChatContext'

export const useChat = () => {
    const {
        messages,
        addMessage,
        isOpen,
        unreadCount,
        setUnreadCount,
        chatSessionId,
        setChatSessionId,
        sessionEpochRef,
    } = useChatContext()

    const { mutate, isMutating } = useApiMutation<SendChatMessageRequest, { message: string }, ChatMessageResponse>({
        url: urlRepository.chatbotMessages,
        method: 'POST',
    })

    const sendMessage = useCallback(
        async (text: string) => {
            const epochAtSend = sessionEpochRef.current
            addMessage({ id: Date.now(), role: 'user', content: text })

            try {
                const response = await mutate({
                    message: text,
                    ...(chatSessionId ? { chatSessionId } : {}),
                })

                if (sessionEpochRef.current !== epochAtSend) return

                if (response) {
                    addMessage({
                        id: response.messageId ?? Date.now(),
                        role: 'assistant',
                        content: response.answer,
                    })
                    if (response.chatSessionId) setChatSessionId(response.chatSessionId)
                    if (!isOpen) setUnreadCount(unreadCount + 1)
                }
            } catch {
                if (sessionEpochRef.current !== epochAtSend) return
                addMessage({
                    id: Date.now(),
                    role: 'assistant',
                    content:
                        'Sorry, the agent is unavailable right now. Please contact DL-DataExperimentation@thehutgroup.com.',
                })
            }
        },
        [isOpen, unreadCount, chatSessionId]
    )

    return { messages, sendMessage, isLoading: isMutating }
}
